import { FundCentreState } from '@/store/fundCentre/typings';

export const initialFundCentreState: FundCentreState = {
  funds: [],
  allFundsCount: 0,
  fundsInFocusCount: 0,
  searchByISIN: false,
  shareclassMappings: {},
  currentPage: 1,
  paginationMaxPages: 1,
  searchQuery: {
    id: '',
    name: '',
    isin: '',
  },
  requestPayloadAssets: {
    countryCode: '',
    investorTypes: '',
    jurisdiction: '',
    language: '',
    site: '',
  },
  appliedFilters: [],
  selectedDate: null,
  selectedTab: 'overview',
  fundDetailsPageUrl: '',
  activeTabKey: 0,
  paginationData: {
    take: 20,
    skip: 0,
  },
};
